<template>
    <section class="search">
        <input
            v-model="searchTerm"
            type="text"
            placeholder="Search"
            @keyup="search"
        />

        <span class="icon-search"></span>
    </section>
</template>

<script>
export default {
    props: {
        prepopulate: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            searchTerm: this.prepopulate,
            lastSearchTerm: this.prepopulate,
            timeout: null,
            delay: 500,
        }
    },

    watch: {
        prepopulate() {
            // clears search term if navigating to same page from side bar
            this.searchTerm = this.prepopulate
        },
    },

    methods: {
        search() {
            clearTimeout(this.timeout)

            this.timeout = setTimeout(() => {
                if (this.searchTerm === this.lastSearchTerm) {
                    return
                }

                this.lastSearchTerm = this.searchTerm

                this.$emit('search', this.searchTerm)
            }, this.delay)
        },
    },
}
</script>
